import type { FacilityUser } from './FacilityUser';

export class Facility {
  constructor(
    readonly id: string,
    readonly accessType: 'VIEW' | 'EDIT',
    readonly facilityUsers: FacilityUser[],
  ) {}
}
